import { gql } from '@apollo/client';

export const FETCH_REPORT_DEFINITION = gql`
    query fetchReportDefinition($filter: ReportDefinitionFilter!) {
        facility {
            id
            reportDefinitions(filter: $filter) {
                id
                alias
                name
                description
                activeFromTime
                activeToTime
                type {
                    id
                    name
                    description
                    platform
                    helpUrl
                }
                reportingPeriod {
                    criteria {
                        startOffset
                        endOffset
                        fixedDurationSeconds
                        cronExpression
                    }
                }
                printLandscapeOrientation
                locale
                startYAxisFromZero
                schedules {
                    id
                }
                settings
                reportSettings {
                    allowSubminutelyData
                    maxReportDays
                }
                powerBiCustomReportId
            }
        }
    }
`;
